<template>
  <v-row justify-center>
    <v-dialog v-model="dialogFlag" id="dialogFlag" persistent max-width="800">
      <v-card>
        <v-card-title class="headline text-center">{{ textoTitulo }}</v-card-title>
        <v-card-text justify="center" class="text-xs-center text-center">
          <v-icon text-xs-center x-large color="amber">warning</v-icon>
        </v-card-text>
        <v-card-text class="text-center" style=" font-size: 16px;" v-if="itemAdd.length != 0"> INMUEBLES ASOCIADOS A OTRA OPERACIONES QUE SE AÑADIRÁN A ESTA: </v-card-text>
        <v-layout wrap justify-center >
          <v-data-table
            :headers="headers"
            :items="itemAdd"
            sort-by="code"
            style="width: 700px"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" >
                  <td class="text-xs-left">{{ item.nombreInmueble }}</td>
                  <td class="text-xs-left">{{ item.codigo }}</td>
                  <td class="text-center">
                    <v-flex row justify-center>
                      <v-checkbox v-model="selected" id="selected" :value="item" :false-value="!selected" multiple></v-checkbox> 
                    </v-flex> 
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-layout>
        <v-card-actions class="text-xs-center justify-center pt-10" v-if="itemAdd.length != 0" >
          <v-btn text @click="$emit('add', selected)" >{{localization.add}}</v-btn> 
        </v-card-actions>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn text  color="red" @click="$emit('cancel')">{{localization.cancelar}}</v-btn> 
        </v-card-actions> 
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialogFlag: Boolean,
    text: String,
    textoTitulo: {
      type: String,
      default: 'Eliminar'
    },
    botonOnly: Boolean,
    itemAdd: {
      type: Array,
      default:() => []
    }
  },
  data () {
    return {
      selected: [],
    }
  },
   computed: {
    localization(){
      return this.$t('popUpSeleccionarInmueblesAsociadosAOperacion')
    },
    headers () {
      return [
        { text: 'NOMBRE DEL INMUEBLE', value: 'nombreInmueble', sortable: true, align: 'left' },
        { text: 'OPERACIÓN ASOCIADA ACTUAL', value: 'codigo', sortable: true, align: 'left' },
        { text: 'AÑADIR', align: 'center' }
      ]
    },
    },
   watch: {
    itemAdd() {
      this.selected = this.itemAdd
      
  }}
}
</script>
